export enum AnalyticsEvent {
  MINIAPP_READY = 'miniapp_ready',
  MINIAPP_LOAD = 'miniapp_load',
}
